import { Component, Input, Output, ViewChild, EventEmitter, AfterViewChecked } from '@angular/core';

declare var jQuery: any;

@Component({
  selector: 'ch-member-invalid-plan-modal-dialog',
  templateUrl: './member-invalid-plan-modal-dialog.component.html',
  styleUrls: ['./member-invalid-plan-modal-dialog.component.css'],
})
export class MemberInvalidPlanModalDialogComponent implements AfterViewChecked {
  @Input() public show: boolean;
  @Output() public close: EventEmitter<any> = new EventEmitter();
  @ViewChild('modal') private modal;

  ngAfterViewChecked() {
    if (!this.show) {
      return;
    }
    jQuery(this.modal.nativeElement)
      .modal({
        backdrop: false,
      })
      .on('hidden.bs.modal', e => {
        this.close.emit(e);
      });
  }

  public closeDialog() {
    jQuery(this.modal.nativeElement).modal('hide');
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/member-invalid-plan-modal-dialog/member-invalid-plan-modal-dialog.component.ts